import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
// import dayjs from "dayjs";
// import { navigate } from "gatsby";
// import { analytics, logEvent } from "../../../utils/firebase";
import { GET_QUIZ_RESULTS } from "./query";

export const fetchQuizResults = createAsyncThunk("quiz/fetchQuizResults", async (childId) => {
  try {
    const data = JSON.stringify({
      query: GET_QUIZ_RESULTS,
      variables: { childId },
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://montessori-graphql-server-27e6d567583f.herokuapp.com/graphql",
      headers: {
        "Content-Type": "application/json",
        "x-monti-website":
          "6kqJaku3GHyXWuzAguwbEgw88KXf9Xjnhqwdq987dwqldkmdq9wd80dqwdlwqkdmqwd98w7dqwd",
      },
      data: data,
    };

    const response = await axios.request(config);

    return response?.data?.data ? response.data.data : null;
  } catch (error) {
    console.log("fetchQuizResults", error);
  }
});

const initialState = {
  childName: null,
  quizResults: null,
  // "idle" | "loading" | "done" | "error" (used by the v2 page for skeleton / fallback states)
  status: "idle",
};

export const quizResultSlice = createSlice({
  name: "quizResult",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get quiz questions and answers from server
    builder.addCase(fetchQuizResults.fulfilled, (state, action) => {
      state.quizResults = action.payload;
      state.childName = action.payload?.quizResults?.quizResultsSection?.childName || null;
      state.status = action.payload?.quizResults ? "done" : "error";
    });
    builder.addCase(fetchQuizResults.rejected, (state, action) => {
      console.log(action.error);
      state.status = "error";
    });
    builder.addCase(fetchQuizResults.pending, (state, action) => {
      state.status = "loading";
    });
  },
});

export const {} = quizResultSlice.actions;

export default quizResultSlice.reducer;
